module.exports = __webpack_public_path__ + "img/dataTypeSelectedShort.3615894a.png";